module.exports = __webpack_public_path__ + "img/pr-11.68aef6a7.png";